<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OJ796R/tc-custom/9780830863891.jpg?1696024617866" alt="This image is the cover for the book God's Big Picture"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">God's Big Picture
      </h1>
      <p class="bookDescription body article font2">
        <p>Sixty-six books written by forty people over nearly 2,000 years, in two languages and several different genres. A worldwide bestseller published in countless sizes and bindings, translations and languages. Sworn by in court, fought over by religious people, quoted in arguments. The Bible is clearly no ordinary book. How can you begin to read and understand it as a whole? In this excellent overview, Vaughan Roberts gives you the big picture—showing how the different parts of the Bible fit together under the theme of the kingdom of God. He provides both the encouragement and the tools to help you read the Bible with confidence and understanding. And he points you to the Bible's supreme subject, Jesus Christ, and the salvation God offers through him.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Vaughan Roberts
      </h2>
      
      <p class="authorDescription body article"><p>Vaughan Roberts is rector of St. Ebbe's Church in Oxford, England, and author of <em>God's Big Picture</em> and <em>Life's Big Questions.</em> He is also a popular speaker at Spring Harvest and a founding member of "9:38" which encourages people to consider full-time gospel ministry.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1faa1927